export default function isDefined(value) {
  if (value === 0) return false;
  if (value === null) return false;
  if (value === undefined) return false;
  return true;
}
